import { useEffect, useState } from 'react';
import type { GetMemberRequestsAvailabilityResponse } from 'shared/src/api/memberRequestsAvailabilityService/getMemberRequestsAvailability';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

export const useLogDisplayRequestCoupon = (
  memberRequestAvailable?: GetMemberRequestsAvailabilityResponse,
) => {
  const [isLogged, setIsLogged] = useState(false);
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  useEffect(() => {
    if (isLogged) return;

    if (memberRequestAvailable) {
      if (memberRequestAvailable.availability.is_available_request) {
        const logged = logMarketAnalytics({
          name: 'DISPLAY_REQUEST_COUPON',
        });
        setIsLogged(logged);
      }
    }
  }, [logMarketAnalytics, memberRequestAvailable, isLogged]);
};
